import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import autobind from 'common/decorators/autobind.js';
import Checkbox from 'core/components/Checkbox.js';
import HospitalHealthFundPicker from 'directory/components/HospitalHealthFundPicker.js';
import Icon from 'core/components/Icon.js';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HospitalHealthFundInfo extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    @autobind
    toggleCheckbox() {
        this.context.updateStore({
            showOnlyGapScheme: !this.context.showOnlyGapScheme,
            page: 1,
        });
    }

    @autobind
    toggleInNetworkHospitalCheckbox() {
        this.context.updateStore({
            inNetworkHospitalFilter: !this.context.inNetworkHospitalFilter,
            page: 1,
        });
    }

    renderCheckbox() {
        const {
            showOnlyGapScheme,
            promotedGapSchemePractitionerLength,
        } = this.context;
        const {gapSchemeId} = this.context.rootStore.healthFundStore;
        if (gapSchemeId && promotedGapSchemePractitionerLength) {
            return (
                <ul className="options">
                    <li>
                        <label>
                            <input
                                checked={showOnlyGapScheme}
                                onChange={this.toggleCheckbox}
                                type="checkbox"
                            />
                            <Icon name="checkbox" />
                            {
                                'Only show practitioners offering guaranteed no gap options'
                            }
                        </label>
                    </li>
                </ul>
            );
        } else {
            return null;
        }
    }

    renderInNetworkHospitalCheckbox() {
        const {
            inNetworkHospitalFilter,
            rootStore: {
                healthFundStore: {healthFund},
            },
        } = this.context;
        return (
            <>
                <span
                    dangerouslySetInnerHTML={{
                        __html: healthFund.inNetworkHospitalInformation,
                    }}
                ></span>
                <li className="filters">
                    <Checkbox
                        className="filter"
                        checked={inNetworkHospitalFilter}
                        name="in-network-hospital"
                        onChange={this.toggleInNetworkHospitalCheckbox}
                    >
                        {'In hospital network'}
                    </Checkbox>
                </li>
            </>
        );
    }

    renderText() {
        const {
            specialty,
            rootStore: {
                paramStore: {isReferrals},
            },
        } = this.context;
        if (isReferrals) {
            return specialty?.isMedical
                ? 'Your patient’s medical costs may be reduced when the practitioner uses a health fund gap scheme for hospital treatment.'
                : 'Your patient’s treatment costs may be reduced when the practitioner participates in a health fund member arrangement.';
        }

        return 'Your treatment costs may be reduced when the practitioner participates in a health fund member arrangement.';
    }

    render() {
        const {
            paramStore: {hasSkin, isClient},
            healthFundStore: {healthFunds, healthFund},
        } = this.context.rootStore;
        const isHFInfoHidden =
            (hasSkin && !isClient) || healthFunds.length === 0;

        if (isHFInfoHidden) {
            return null;
        }

        return (
            <form aria-selected={!!healthFund?.id} className="fund-info">
                <HospitalHealthFundPicker />
                <span>{this.renderText()}</span>
                {healthFund && this.renderCheckbox()}
            </form>
        );
    }
}
